export default "__VITE_ASSET__7f66bfa6__"